// imports
import Component from 'minsky-kit/js/components/Component';

// class definition
export default class DownloadForm extends Component {
    // constructor
    constructor (args = {}, objectName = 'DownloadForm') {
        args.debug = args.debug || false;

        // super
        super(args, objectName);

        this.fileId = this.$el.dataset.fileId;
        this.$hiddenField = this.$el.querySelector('input[type=hidden][name=file_id]');

        if (this.fileId && this.$hiddenField) {
          this.$hiddenField.value = this.fileId;
        }
    }

    // methods
    destroy () {
        // super destroy
        super.destroy();
    }
}

// Utils

// Event handlers
